function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Fill & sign"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.72,44.87a1,1,0,0,0,0,1.42,1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29L50.79,19.62a3,3,0,0,0,0-4.24l-2.17-2.17a3.06,3.06,0,0,0-4.24,0L17.29,40.29a.13.13,0,0,1,0,.05.86.86,0,0,0-.1.16.81.81,0,0,0-.1.18s0,0,0,0l-2,7a1,1,0,0,0,.16.87,1,1,0,0,0,.8.4H29a1,1,0,0,0,.51-.14l4.19-2.51,1.47,2.2A1,1,0,0,0,36,49l.19,0A1,1,0,0,0,37,48.2l.34-1.7.75,1.87a1,1,0,0,0,1.89-.1L41.19,44l1.89,4.41A1,1,0,0,0,44,49h5a1,1,0,0,0,0-2H44.66l-2.74-6.39a1,1,0,0,0-1-.61,1,1,0,0,0-.9.73l-1.2,4.18-.91-2.28A1,1,0,0,0,36,42.8l-.53,2.64-.66-1a1,1,0,0,0-1.34-.31L28.72,47H17.33l1.56-5.48,26.9-26.9a1,1,0,0,1,1.42,0l2.17,2.17a1,1,0,0,1,0,1.42Z"
}));

var SvgJoratoSignableIcon = function SvgJoratoSignableIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#384336",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoSignableIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-signable-icon.57884c19.svg";
export { ForwardRef as ReactComponent };